import {
    useCallback, useState,
} from 'react';
import { useParams } from 'react-router-dom';
import Close from 'components/icons/close';
import SearchIcon from 'components/icons/search';
import { EntityGet } from 'data/firestore/types';
import { Customer } from 'data/firestore/agent/customer/types';
import useDebouncedState from 'hooks/useDebouncedState';
import CustomerMessages from './messages';
import {
    CloseButton, Container, Content, Header, SearchInput, Title, TitleContainer, FilterButton,
} from '../styled';
import useCustomersWithMessages from './hooks/useCustomersWithMessages';

interface ConversationsListProps {
    onRequestClose?: () => void;
    onCustomerSelect?: ((customer: EntityGet<Customer>) => void);
}

const ConversationsList = ({
    onRequestClose = () => {},
    onCustomerSelect,
}: ConversationsListProps) => {
    const { agentId = '' } = useParams();
    const [showMessages, setShowMessages] = useState<string>('all');
    const [search, setSearch] = useDebouncedState<string>('', 500);
    const [activePage, setActivePage] = useState<number>(1);

    const { isLoading, customers } = useCustomersWithMessages({
        agentId,
        searchQuery: search,
        showUnreadOnly: showMessages === 'unread',
        pageSize: 150,
    });

    const searchCustomers = useCallback(
        (value: string) => {
            if (activePage > 1) setActivePage(1);
            setSearch(value);
        },
        [activePage, setSearch],
    );

    return (
        <Container>
            <Header>
                <TitleContainer>
                    <Title className="rainbow-m-left_x-small">Chats</Title>
                    <SearchInput
                        icon={<SearchIcon />}
                        placeholder="Type something"
                        onChange={(e) => searchCustomers(e.target.value)}
                    />
                </TitleContainer>
                <FilterButton value={showMessages} onChange={setShowMessages} />
                <CloseButton icon={<Close />} onClick={onRequestClose} />
            </Header>
            <Content>
                <CustomerMessages
                    data={customers}
                    isLoading={isLoading}
                    onClick={onCustomerSelect}
                />
            </Content>
        </Container>
    );
};

export default ConversationsList;
